export default {
	'地毯颜色选择': 'Carpet color selection',
	'请选择需要的地毯颜色': 'Please choose the carpet color you want.',
	'不需要地毯': 'No carpet required',
	'上一步': 'Previous',
	'下一步': 'Next',
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/drawings/drawingsCarpet.js